import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from './AuthContext';
import { jwtDecode } from 'jwt-decode';

const AccountPage = () => {
  const { token } = useAuth();
  const avatarInputRef = useRef();
  const coverInputRef = useRef();

  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({
    display_name: '',
    handle: '',
    avatar_url: '',
    cover_url: '',
    bio: '',
    subscriptions: 0
  });
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [media, setMedia] = useState([]);
  const [projectMedia, setProjectMedia] = useState([]);
  const [username, setUsername] = useState('');

  const [newMedia, setNewMedia] = useState({
    title: '',
    location: '',
    file: null,
    visibility: 'PUBLIC'
  });
  const [showToast, setShowToast] = useState(false);
  const [errorToast, setErrorToast] = useState(null);
  useEffect(() => {
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      setUsername(decoded?.preferred_username || '');
    } catch (err) {
      console.error('Erreur lors du décodage du token:', err);
    }

    fetch("/myProfil", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        setProfile(data);
        setForm({
          display_name: data.display_name || '',
          handle: data.handle || '',
          avatar_url: data.avatar_url || '',
          cover_url: data.cover_url || '',
          bio: data.bio || '',
          subscriptions: data.subscriptions || 0
        });
      });
  }, [token]);

  useEffect(() => {
    if (!username || !token) return;

    fetch("/media/me", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (!Array.isArray(data)) return;
        setMedia(data);
      });

    fetch("/project-media/me", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (!Array.isArray(data)) return;
        setProjectMedia(data);
      });
  }, [username, token]);

  const handleSave = () => {
    fetch("/myProfil", {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(form)
    })
      .then(res => res.json())
      .then(data => {
        alert("Profil mis à jour !");
        setEditMode(false);
        setProfile(prev => ({ ...prev, ...form }));
      });
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const data = new FormData();
    data.append('avatar', file);
    fetch("/myProfil/avatar", {
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}` },
      body: data
    })
      .then(res => res.json())
      .then(data => setForm(prev => ({ ...prev, avatar_url: data.url })));
  };

  const handleCoverChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const data = new FormData();
    data.append('cover', file);
    fetch("/myProfil/cover", {
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}` },
      body: data
    })
      .then(res => res.json())
      .then(data => setForm(prev => ({ ...prev, cover_url: data.url })));
  };

 const handleUploadMedia = async (e) => {
  e?.preventDefault?.(); // empêche comportement par défaut s'il vient d'un <form>

  // ✅ Vérification des champs requis
  if (!newMedia.file || !newMedia.title.trim() || !newMedia.location.trim()) {
    setErrorToast("Merci de remplir tous les champs !");
    setTimeout(() => setErrorToast(null), 3000);
    return;
  }

  console.log("📤 Tentative d'upload média :", newMedia);

  const formData = new FormData();
  formData.append("media", newMedia.file);
  formData.append("title", newMedia.title.trim());
  formData.append("location", newMedia.location.trim());
  formData.append("visibility", newMedia.visibility || "PUBLIC");

  try {
    const response = await fetch("/upload", {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });

    let result;
    try {
      result = await response.json();
    } catch (parseError) {
      console.error("❌ Réponse non JSON reçue :", parseError);
      setErrorToast("Réponse serveur invalide.");
      setTimeout(() => setErrorToast(null), 3000);
      return;
    }

    if (!response.ok) {
      console.warn("⚠️ Upload échoué :", result);
      setErrorToast(result?.error || "Erreur lors de l'upload.");
      setTimeout(() => setErrorToast(null), 3000);
      return;
    }

    // ✅ Succès
    console.log("✅ Média ajouté :", result);
    setMedia(prev => [result, ...prev]);
    setNewMedia({ title: '', location: '', file: null, visibility: 'PUBLIC' });
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);

  } catch (err) {
    console.error("❌ Erreur réseau :", err);
    setErrorToast("Erreur réseau ou serveur.");
    setTimeout(() => setErrorToast(null), 3000);
  }
};



  const renderVisibilityBadge = (visibility) => {
    return (
      <span
        className={`badge px-3 py-1 rounded-pill fw-semibold ${visibility === 'PUBLIC' ? 'bg-gradient text-light bg-success' : 'bg-gradient text-dark bg-warning'
          }`}
      >
        {visibility === 'PUBLIC' ? '🌍 Public' : '🔒 Privé'}
      </span>
    );
  };

  if (!profile) return <div className="p-5">Chargement...</div>;

  return (
    <div className="container py-4" >
      {showToast && (
        <div className="alert alert-success alert-dismissible fade show position-fixed top-40 start-50 translate-middle-x mt-3 z-3" role="alert" style={{ zIndex: 9999 }}>
          ✅ Média ajouté avec succès !
          <button type="button" className="btn-close" onClick={() => setShowToast(false)}></button>
        </div>
      )}

      {errorToast && (
        <div className="alert alert-danger alert-dismissible fade show position-fixed top-40 start-50 translate-middle-x mt-3 z-3" role="alert" style={{ zIndex: 9999 }}>
          ❌ {errorToast}
          <button type="button" className="btn-close" onClick={() => setErrorToast(null)}></button>
        </div>
      )}

      {/* Couverture */}
      <div className="mb-4 position-relative rounded-4 overflow-hidden" style={{ paddingTop: '50px',height: '300px'}}>
        {form.cover_url && (
          <img src={`${form.cover_url}`} alt="cover" className="w-100 h-100 object-fit-cover" />
        )}
        <button
          className="btn btn-sm btn-dark position-absolute bottom-0 end-0 m-2"
          onClick={() => coverInputRef.current.click()}
        >
          Modifier la couverture
        </button>
        <input type="file" accept="image/*" hidden ref={coverInputRef} onChange={handleCoverChange} />
      </div>

      {/* Profil utilisateur */}
      <div className="card shadow-sm rounded-4 p-4 mb-5">
        <div className="d-flex align-items-center mb-3">
          <div onClick={() => avatarInputRef.current.click()} style={{ cursor: 'pointer' }}>
            <img
              src={form.avatar_url ? `${form.avatar_url}` : "https://via.placeholder.com/80?text=?"}
              alt="avatar"
              className="rounded-circle me-3 border"
              style={{ width: 80, height: 80, objectFit: 'cover' }}
            />
          </div>
          <input type="file" accept="image/*" hidden ref={avatarInputRef} onChange={handleAvatarChange} />
          <div>
            {editMode ? (
              <>
                <input className="form-control mb-2" value={form.display_name} onChange={e => setForm({ ...form, display_name: e.target.value })} />
                <input className="form-control mb-2" value={form.handle} onChange={e => setForm({ ...form, handle: e.target.value })} />
              </>
            ) : (
              <>
                <h5 className="mb-0 fw-bold">{profile.display_name}</h5>
                <p className="text-muted mb-1">{profile.handle}</p>
                <p className="text-muted mb-0">Abonnements : {profile.subscriptions ?? 0}</p>
              </>
            )}
          </div>
        </div>

        <div className="mb-3">
          {editMode ? (
            <textarea className="form-control" rows="3" value={form.bio} onChange={e => setForm({ ...form, bio: e.target.value })} />
          ) : (
            <p className="text-muted">{profile.bio}</p>
          )}
        </div>

        <div className="text-end">
          {editMode ? (
            <>
              <button className="btn btn-secondary me-2" onClick={() => setEditMode(false)}>Annuler</button>
              <button className="btn btn-primary" onClick={handleSave}>💾 Enregistrer</button>
            </>
          ) : (
            <button className="btn btn-outline-primary" onClick={() => setEditMode(true)}>✏️ Modifier</button>
          )}
        </div>
      </div>

      {/* Formulaire ajout de média */}
      <div className="card p-4 mb-5">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">📤 Ajouter un média </h5>
          <button
            className="btn btn-light border-0"
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              fontSize: '20px',
              lineHeight: '1',
              transition: 'transform 0.3s ease',
              transform: showUploadForm ? 'rotate(180deg)' : 'rotate(0deg)'
            }}
            onClick={() => setShowUploadForm(!showUploadForm)}
            aria-label="Afficher/masquer"
          >
            ▼
          </button>
        </div>

        {showUploadForm && (
          <div className="mt-4">
            <div className="mb-3">
              <label className="form-label">Titre</label>
              <input
                className="form-control"
                value={newMedia.title}
                onChange={e => setNewMedia({ ...newMedia, title: e.target.value })}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Lieu</label>
              <input
                className="form-control"
                value={newMedia.location}
                onChange={e => setNewMedia({ ...newMedia, location: e.target.value })}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Fichier média</label>
              <input
                type="file"
                className="form-control"
                onChange={e => setNewMedia({ ...newMedia, file: e.target.files[0] })}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Visibilité</label>
              <select
                className="form-select"
                value={newMedia.visibility}
                onChange={e => setNewMedia({ ...newMedia, visibility: e.target.value })}
              >
                <option value="PUBLIC">🌍 Public – Visible par tous</option>
                <option value="PRIVATE">🔒 Privé – Visible seulement par vous</option>
              </select>
            </div>
            <button className="btn btn-primary" onClick={handleUploadMedia}>
              📥 Ajouter
            </button>
          </div>
        )}
      </div>

      <section>
        <h4 className="mb-4">📷 Médias hors projets</h4>
        {media.length > 0 ? (
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
            {media.map(m => (
              <div className="col" key={m.id}>
                <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden media-card">
                  <div className="media-wrapper">
                    {m.file_path.match(/\.(jpg|jpeg|png)$/i) ? (
                      <img src={`/uploads/${m.file_path}`} className="img-fluid" alt="media" />
                    ) : (
                      <video src={`/uploads/${m.file_path}`} className="img-fluid" controls />
                    )}
                  </div>
                  <div className="p-3">
                    <h6 className="fw-semibold mb-1 text-truncate">{m.title}</h6>
                    <p className="text-muted small mb-0">{m.description}</p>
                    {renderVisibilityBadge(m.visibility)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted">Aucun média personnel trouvé.</p>
        )}
      </section>

      <hr className="my-5" />

      <section>
        <h4 className="mb-4">🎬 Médias liés à un projet</h4>
        {projectMedia.length > 0 ? (
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
            {projectMedia.map(m => (
              <div className="col" key={m.id}>
                <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden media-card">
                  <div className="media-wrapper">
                    {m.file_path.match(/\.(jpg|jpeg|png)$/i) ? (
                      <img src={`/uploads/${m.file_path}`} className="img-fluid" alt="media" />
                    ) : (
                      <video src={`/uploads/${m.file_path}`} className="img-fluid" controls />
                    )}
                  </div>
                  <div className="p-3">
                    <h6 className="fw-semibold mb-1 text-truncate">{m.title}</h6>
                    <p className="text-muted small mb-0">{m.description}</p>
                    <div className="d-flex gap-2 align-items-center">
                      {renderVisibilityBadge(m.visibility)}

                      <a
                        href={`/projects/${m.project_id}/recap`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="badge bg-secondary text-decoration-none"
                        style={{ cursor: 'pointer' }}
                      >
                        🔗 Voir le projet #{m.project_id}
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted">Aucun média lié à un projet.</p>
        )}
      </section>
    </div>
  );
};

export default AccountPage;
